import { render, staticRenderFns } from "./test-panel.vue?vue&type=template&id=a366818a&scoped=true"
import script from "./test-panel.vue?vue&type=script&lang=js"
export * from "./test-panel.vue?vue&type=script&lang=js"
import style0 from "./test-panel.vue?vue&type=style&index=0&id=a366818a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a366818a",
  null
  
)

export default component.exports